import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton, mobileOrderPickupButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/4rBO1hTdBuir4HpEaMGG/locations/5gukjIqsBIlkOUx8w87s`}
            >
              <CFView hover>
                <CFImage
                  src={mobileOrderPickupButton}
                  w="100%"
                  maxWidth="230px"
                  alt="mobile pickup button"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/4rBO1hTdBuir4HpEaMGG/locations/5gukjIqsBIlkOUx8w87s`}
            >
              <CFView hover>
                <CFImage src={orderPickupButton} maxWidth="220px" alt="About" />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
